/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import ModalBodyLayout from '../shared/ModalBodyLayout';
import { useCardStatus, useUserCardProvider } from '../../utilities/sharedHooks/user';
import { showAlert } from '../../utilities/notifications';
import { validateCVV } from '../../utilities/formValidation';
import { CARD_MONAVATE_ACTIVATE } from './mutations';
import BoxInput from '../../components/BoxInputs';
import { FLOWS, sendStats } from '../../services/mixpanel';
import { MXP_CARD_MANAGEMENT_ACTIVATE_CONFIRM } from './mixpanel-events';

const EnterCardCode = (props) => {
  const { t: translate } = useTranslation();
  const { cardProvider } = useUserCardProvider();

  const [isValid, setIsValid] = useState(true);

  const [cardCode, setCardCode] = useState('');

  const { refetch: getCardStatus } = useCardStatus({ enabled: false });

  const { mutate: activateCard, isLoading } = useMutation(CARD_MONAVATE_ACTIVATE, {
    onSettled: (data, error) => {
      sendStats(
        MXP_CARD_MANAGEMENT_ACTIVATE_CONFIRM,
        { data, error, cardProvider },
        FLOWS.CARD_MANAGEMENT
      );
      if (!error && data && data?.success) {
        showAlert({
          message: translate('activate_card_success_msg'),
          type: 'success',
        });
        getCardStatus();
        props.hidePopup();
      } else if (error) {
        showAlert({ message: error.message, type: 'danger' });
      } else {
        showAlert({ message: translate('activate_card_error_msg'), type: 'danger' });
      }
    },
  });

  const handleSubmitForm = (e) => {
    e.preventDefault();
    if (!validateCVV(cardCode)) {
      setIsValid(false);
      return false;
    }
    activateCard({ cvv: cardCode });
    return true;
  };

  const handleChange = (e) => {
    setCardCode(e);
  };

  const handleBlur = (e) => {
    if (e.name === 'cardCode') {
      if (!validateCVV(cardCode)) {
        setIsValid(false);
      }
    }
  };

  const clearError = () => {
    setIsValid(true);
  };

  return (
    <ModalBodyLayout
      withBack={false}
      renderHeader={() => (
        <div className="flex-row-center w-100">
          <b className="text-f5 text-dark">{translate('activate_card_title')}</b>
        </div>
      )}>
      <div className="mt-4">
        <p className="text-f5 text-dark p-0">{translate('activate_card_subtitle')}</p>
      </div>
      <form onSubmit={handleSubmitForm}>
        <div className="form-group my-4 pt-2 pb-4">
          <BoxInput
            type="tel"
            className={`form-control-input border-0 ${isValid ? '' : 'has-error '}`}
            placeholder={translate('activate_card_input_placeholder')}
            name="cardCode"
            value={cardCode}
            amount={3}
            handleOutputString={handleChange}
            inputRegExp={RegExp('^[0-9]$')}
            handleBlur={handleBlur}
            handleFocusFn={clearError}
            required
          />
        </div>

        <div className="d-flex justify-content-center">
          <button
            loading={isLoading ? 'true' : 'false'}
            disabled={!cardCode}
            type="submit"
            className="btn btn-primary py-3 modal__footer-btn w-100">
            {translate('continue_btn_title')}
          </button>
        </div>
      </form>
    </ModalBodyLayout>
  );
};

export default EnterCardCode;

EnterCardCode.propTypes = {
  hidePopup: PropTypes.func.isRequired,
};
